//hooks
import { useState, useEffect } from "react";
import { useApi } from "../../hooks/useApi";

//css file
import styles from "./About.module.css"

//api
import { GetSettings } from "../../api/setting/GetSettings";

//type
import { settingsTypeRes } from "../../api/setting/type/SettingsType";

//mui
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ReplayIcon from '@mui/icons-material/Replay';

//translate
import { useTranslation } from 'react-i18next';
import i18n from "../../translate/i18n";

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

const params  = [
  "about.en_section_home_page",
  "about.ar_section_home_page",
  "about.image1", 
  "about.en_section_about_page", 
  "about.ar_section_about_page",
  "about.image2", 
  "about.video",
]


const About = () => {
  const {t} = useTranslation()
  let [aboutData, setAboutData] = useState<settingsTypeRes[]>();

  const {
    loading: aboutLoading,
    error: aboutError,
    HandlerApi: aboutApi
  } = useApi(GetSettings, "GET");

  useEffect(() => {
    const fetchData = async () => {
      const aboutData = await aboutApi(params);
      setAboutData(aboutData.data);
      };
    fetchData();
    }, []);

  const otherLangKeyPrefix = i18n.language === 'ar' ? 'about.ar_' : 'about.en_';
  const filteredAboutContent = aboutData?.filter(item => {
      const key = item.key;
      const isCurrentLangContent = key.startsWith(otherLangKeyPrefix);
      const isGenericOrCurrent = !key.startsWith(otherLangKeyPrefix);
      return isCurrentLangContent || (isGenericOrCurrent && !(key.includes('_section_home_page') || key.includes("_section_about_page")));
  });

  return (
    <div className={`${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"} text-primaryColor`}>
      {aboutLoading
      ? 
      <div className='flex justify-center w-full min-h-[70vh]'>
          <CircularProgress className="m-auto"/>
      </div>
      :
      aboutError
      ?
      <div className='cursor-pointer flex justify-center w-full min-h-[70vh]'>
          <ReplayIcon onClick={()=>{aboutApi(params)}} className='!text-[40px] m-auto' />
      </div>
      :<>
        <div className={`h-[500px] max-md:h-72 relative image ${styles.image}`}>
          <img className="w-full h-full object-cover" src={`${storageURL}/${filteredAboutContent?.[4].value}`} alt="no_photo"/>
          <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 translate-y-1/2 text-white md:text-2xl sm:text-sm max-sm:text-[13px]">{t("about")}</p>
        </div>
        <div className="bg-[#EDEBDF]">
          <Box
          sx={{
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center", 
            flexDirection: {md: "row",xs: "column"},
            padding: {md: "40px", xs: "20px"},
            direction: i18n.language === "ar" ? "rtl" : "ltr"
            }} 
            className="max-w-[1560px] m-auto gap-[10px]"
            >
                <Box sx={{ width: { md: "50%", xs: "100%" } }} className="w-1/2">
                  <div className={`aboutSection leading-10 ${styles.aboutSection} mb-5 ${i18n.language === "en" ? "en font-palab" : "ar font-helvetica-arabic-bold"}`} 
                  dangerouslySetInnerHTML={{ __html: filteredAboutContent?.[0].value  || "" }}
                  />
                </Box>
                <Box
                  sx={{ width: { md: "50%" }, marginTop: { md: "0px", xs: "10px" } }}
                  className="max-w-[600px] max-h-[500px]"
                >
                  <Box
                    sx={{ borderRadius: { md: "15px", xs: "25px" } }}
                    className="w-full h-full"
                    component="img"
                    src={`${storageURL}/${filteredAboutContent?.[3].value}`}
                    alt="no_photo"
                  />
                </Box>
          </Box>
        </div>
        <div dir={i18n.language === "en" ? "ltr" : "rtl"} className="bg-[#223C61] text-white py-10">
          <Box sx={{padding: {md: "40px", xs: "20px"}}} className="max-w-[1560px] m-auto gap-[10px] text-center">
            <div className={`aboutSection aboutHistorySection leading-10 ${styles.aboutSection} ${styles.aboutHistorySection} mb-5 ${i18n.language === "en" ? "en font-palab" : "ar font-helvetica-arabic-bold"}`} 
            dangerouslySetInnerHTML={{ __html: filteredAboutContent?.[1].value || "" }} 
            />
            <video 
            controls 
            className="md:w-[50%] m-auto sm:w-full videoPlayer max-h-[700px] mt-20 object-cover" 
            src={`${storageURL}/${filteredAboutContent?.[2].value}`}/>
          </Box>
        </div>
      </>
      }
    </div>
  )
}

export default About
